import { apiPost } from './client';
import type { AttributionPayload } from '../utils/attribution';

interface SaveResponse {
  status: string;
  channel: string;
  first_seen_at: string | null;
}

export async function saveAttribution(p: AttributionPayload): Promise<SaveResponse> {
  return apiPost<SaveResponse>('/api/attribution', {
    utm_source: p.utm_source,
    utm_medium: p.utm_medium,
    utm_campaign: p.utm_campaign,
    utm_term: p.utm_term,
    utm_content: p.utm_content,
    gclid: p.gclid,
    fbclid: p.fbclid,
    referrer: p.referrer,
    landing_page: p.landing_page,
    seen_at: p.seen_at,
  });
}
